import React from "react";
import _ from "lodash";
import Select from "react-select";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

class PriorityControl extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMoveUp = this.handleMoveUp.bind(this);
    this.handleMoveDown = this.handleMoveDown.bind(this);
  }

  handleChange({ value }) {
    const { onChange } = this.props;
    if (onChange) onChange(value);
  }

  handleMoveUp() {
    const { value, onChange } = this.props;
    if (value <= 1) return;
    if (onChange) onChange(value - 1);
  }

  handleMoveDown() {
    const { value, onChange, options } = this.props;
    if (value >= options.length) return;
    if (onChange) onChange(value + 1);
  }

  render() {
    const { value, options } = this.props;

    const selected = _.find(options, { value });

    const customStyles = {
      control: (provided) => ({
        ...provided,
        minHeight: "24px",
        height: "24px",
        width: "3.5rem",
      }),
      valueContainer: (provided) => ({
        ...provided,
        height: "24px",
        padding: "0",
        lineHeight: 1,
        justifyContent: "center",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0px",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "24px",
        width: "21px",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: "0",
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        width: "1px",
        margin: "2px 0",
        backgroundColor: "#ebeff5",
      }),
    };

    const isFirst = value === 1;
    const isLast = value === options.length;

    return (
      <div className="flex flex-col items-center justify-center gap-1">
        <div
          className={`flex w-20 justify-center ${
            isFirst
              ? "text-gray-400"
              : "cursor-pointer text-gray-600 hover:text-blue-600"
          }`}
          onClick={this.handleMoveUp}
        >
          <FaChevronUp></FaChevronUp>
        </div>

        <Select
          className="text-center text-sm"
          value={selected}
          options={options}
          onChange={this.handleChange}
          styles={customStyles}
        />

        <div
          className={`flex w-20 justify-center ${
            isLast
              ? "text-gray-400"
              : "cursor-pointer text-gray-600 hover:text-blue-600"
          }`}
          onClick={this.handleMoveDown}
        >
          <FaChevronDown></FaChevronDown>
        </div>
      </div>
    );
  }
}

export default PriorityControl;
